import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from "moment-timezone";
import store from "@/store";
import geraData from "../geradata";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default async function $_enviaOrdem() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let ordens = await db.ordemcarregamento.toArray();
  ordens = await ordens.filter(o => o.orcdatanuvem === null);
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
  ordens.forEach((item) => {
    if ((item.orcidnuvem) && (item.orcidnuvem !== 'null')) {
        console.log('put - ', item);
        const payload = {
            orcdatainicio: item?.orcdatainicio,
            orcidusuarioiniciou: Number(item?.orcidusuarioiniciou),
            orcidusuariofinalizou: item?.orcidusuariofinalizou ? Number(item?.orcidusuariofinalizou) : null,
            orcdataalteracao: geraData(),
            orcdatafinalizado: item?.orcdatafinalizado,
            orcdatarobo: null,
            orcidusuario: idusuario,
            id: item.orcidnuvem,
        }
        apirecebimentoweb.put(`/ordemcarregamento/${item.orcidnuvem}`, payload, {
            headers: {
                Authorization: `Bearer ${token.token}`
            }
        }).then((res) => {
            const alteracao = (moment.utc(res.data.orcdataalteracao).format('YYYY-MM-DD HH:mm:ss.SSS'))
            db.ordemcarregamento.update(item.id, {
                orcdataalteracao: alteracao,
                orcdatanuvem: alteracao,
            });
            store.dispatch('cache/atualizaData', { data: alteracao, tabela: 'ordemcarregamento' });
        });    
    }
  }); 
}
